/**
 * The «نوبت حضوری» filter shows in-person booking only.
 *
 * Hamidi, 2026-10-16 (Lead again, msg 25039): «با آن که فیلتر نوبت حضوری انتخاب شده است، انگار باز
 * اولویت با ویزیت آنلاین است». When the patient explicitly asks for an in-person visit, the page does
 * not offer online visits (ghane finding #130).
 *
 * Who decides what (owner, 2026-10-16: the backend decides, the front-end renders):
 * - ranking — semantic-search (es-adapter);
 * - the card's «ویزیت آنلاین» button, the card link and the promoted online-visit card —
 *   search-service (`DoctorResource::actions`/`getUrl`, `resolvePromotedOnlineVisit`); nothing here;
 * - only what the front-end itself builds is handled here: the «ویزیت آنلاین: … تومان» price line
 *   (computed from `consult_services`, below), the consult banner and the presence line
 *   (`consultBanner.tsx`, `.plasmic/ProductCard.tsx`, both via `isInPersonView`).
 */

/** The in-person bucket of the `turn_type` filter (SEAPI facet value). */
export const IN_PERSON_TURN_TYPE = 'non-consult';

export function isInPersonView(turnType: unknown): boolean {
  return turnType === IN_PERSON_TURN_TYPE;
}

/**
 * The card as the in-person view shows it: nothing the online price line can read. search-service keeps
 * `consult_services` in this view on purpose — the profile preview reads it from the cached response —
 * so only this display copy is cleared. Returns the same object when there is nothing to clear, so
 * memoised lists keep their identity.
 */
export function toInPersonCard<T>(item: T): T {
  const { price, consult_services: consultServices } = (item ?? {}) as { price?: unknown; consult_services?: unknown };
  const hasPriceData = !!price || (Array.isArray(consultServices) && consultServices.length > 0);
  if (!hasPriceData) return item;
  return { ...item, price: undefined, consult_services: [] };
}

export function toInPersonResults<T>(items: T[]): T[] {
  let changed = false;
  const out = items.map(item => {
    const next = toInPersonCard(item);
    if (next !== item) changed = true;
    return next;
  });
  return changed ? out : items;
}
